import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
// import { MsalGuard } from '@azure/msal-angular';
import { canActivateAuthRole as KeycloakGuard } from './guards/auth-role.guard';

export const AppRoutes: Routes = [{
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },{
        path: '',
        component: AdminLayoutComponent,
        children: [{
            path: 'dashboard',
            loadChildren: () => import('./dashboard/dashboard.routing').then(x => x.DashboardRoutes)
          }, {
            path: 'usermanagement',
            canActivate: [KeycloakGuard],
            loadChildren: () => import('./usermanagement/usermanagement.routing').then(x => x.UserManagementRoutes)
          }, {
            path: 'patientmanagement',
            canActivate: [KeycloakGuard],
            loadChildren: () => import('./patientmanagement/patientmanagement.routing').then(x => x.PatientManagementRoutes)
          }, {
            path: 'portalmanagement',
            canActivate: [KeycloakGuard],
            loadChildren: () => import('./portalmanagement/portalmanagement.routing').then(x => x.PortalManagementRoutes)
          }, {
            path: '',
            loadChildren: () => import('./disclaimer/disclaimer.routing').then(x => x.DisclaimerRoutes)
          }, {
            path: '',
            loadChildren: () => import('./impressum/impressum.routing').then(x => x.ImpressumRoutes)
          }]
      }/*,
      {
        redirectTo: 'dashboard',
        matcher: (url) => {
          return url.length === 1 && url[0].path.startsWith('code=')
            ? { consumed: url }
            : null;
        },
      }*/
];
